import React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Text from "./Text";
import CircularProgress from "@mui/material/CircularProgress";
import FormHelperText from "@mui/material/FormHelperText";
import TextField_new from "./TextField_new";

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 2;
const BORDER_RADIUS = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP + BORDER_RADIUS,
      width: 250,
    },
    MenuListProps: {
      disablePadding: true,
    },
  },
};

// Define the props type for the component
interface DropdownProps {
  handleChange: any;
  selectedValue: any;
  label?: string;
  sx?: object;
  name?: string;
  size?: "small" | "medium";
  inputLabelSx?: object;
  placeholder?: string;
  loading?: boolean;
  options?: any;
  errorMsg?: string | null;
  defaultValue?: string;
  [key: string]: any; // To allow additional props
}

const TopBarDropdown: React.FC<DropdownProps> = ({
  handleChange,
  selectedValue,
  label = "",
  sx,
  name = "",
  size = "small",
  inputLabelSx,
  placeholder = "",
  loading = false,
  options = [],
  errorMsg = null,
  defaultValue = "",
  input_sx = {},
  disabled = false,
  ...restProps
}) => {  
  return (
    <FormControl fullWidth sx={{ ...sx }}>
      <InputLabel id="dropdown-label" sx={inputLabelSx}>
        {label}
      </InputLabel>
      <Select
        labelId="dropdown-label"
        id="dropdown"
        onChange={handleChange}
        value={selectedValue?.value || ""}
        MenuProps={MenuProps}
        {...restProps}
        disabled={disabled}
        IconComponent={ExpandMoreIcon}
        size={size}
        displayEmpty={true}
        // placeholder={placeholder}
        renderValue={(selected: any) =>
          selected ? options.find((opt:any) => opt.value === selected)?.label : placeholder
        }
        sx={{
          padding: "0 !important",
          "& .MuiSelect-select": {
            padding: "4.5px 15px !important",
            borderRadius: "8px !important",
            height: "auto",
            fontSize: "12px",
            fontFamily: "inherit",
            fontWeight: 600,
            backgroundColor: "#ffd021",
            color: "#606060",
            borderColor: "#606060 !important",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#606060",
          },
          "&.MuiOutlinedInput-root": {
            borderRadius: "8px !important",
            borderColor: "#aeaeae !important",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#AEAEAE !important",
          },
          ...input_sx,
        }}
      >
        {loading ? (
          <MenuItem disabled>
            <CircularProgress size={20} />
          </MenuItem>
        ) : (
          options.map((item: any, i: number) => (
            <MenuItem
              key={i}
              value={item}
              sx={{
                borderBottom: "1px solid #F4F4F6",
                backgroundColor: "#fff",
                color: "#000",
                fontSize: "12px",
                "&.Mui-selected": {
                  backgroundColor: "#FFFBE9 !important",
                },
              }}
            >
              {item.label}
            </MenuItem>
          ))
        )}
      </Select>
      {errorMsg && <FormHelperText error>{errorMsg}</FormHelperText>}
    </FormControl>
  );
};

export default TopBarDropdown;
